"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.BaseAdministrationComponent = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactSpring = require("react-spring");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _nicbaseIcons = require("nicbase-icons");

var _baseWidgetModule = _interopRequireDefault(require("../BaseWidget/base-widget.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var minClickCount = 5;
var rotationDeg = 360;
var clickDuration = 2000;

var BaseAdministrationComponent = function BaseAdministrationComponent(_ref) {
  var className = _ref.className,
      icon = _ref.icon,
      label = _ref.label,
      children = _ref.children;
  var clickCount = (0, _react.useRef)(0);

  var _useState = (0, _react.useState)(0),
      _useState2 = _slicedToArray(_useState, 2),
      rotation = _useState2[0],
      setRotation = _useState2[1];

  var timeoutId = (0, _react.useRef)(null);
  var styles = (0, _reactSpring.useSpring)({
    rotate: "".concat(rotation, "deg")
  });

  var onClick = function onClick() {
    clickCount.current += 1;

    if (!timeoutId.current) {
      timeoutId.current = setTimeout(function () {
        if (clickCount.current >= minClickCount) {
          setRotation(function (prev) {
            return prev + rotationDeg;
          });
        }

        clickCount.current = 0;
        timeoutId.current = null;
      }, clickDuration);
    }
  };

  return /*#__PURE__*/_react["default"].createElement(_reactSpring.animated.div, {
    style: styles,
    className: (0, _classnames["default"])(_baseWidgetModule["default"].widget, className)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _baseWidgetModule["default"].widgetHeader
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _baseWidgetModule["default"].widgetIcon,
    onClick: onClick
  }, icon), /*#__PURE__*/_react["default"].createElement("span", {
    className: _baseWidgetModule["default"].widgetName
  }, label)), /*#__PURE__*/_react["default"].createElement("div", {
    className: _baseWidgetModule["default"].widgetContent
  }, children));
};

exports.BaseAdministrationComponent = BaseAdministrationComponent;
BaseAdministrationComponent.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node,
  icon: _propTypes["default"].node,
  label: _propTypes["default"].string
};
BaseAdministrationComponent.defaultProps = {
  className: '',
  label: '',
  icon: /*#__PURE__*/_react["default"].createElement(_nicbaseIcons.Widget, null),
  children: null
};
var _default = BaseAdministrationComponent;
exports["default"] = _default;